import React, { Component } from 'react';
import ModalEstadosBusquedaUsuarios from './ModalEstadosBusquedaUsuarios'
class ModalEstados extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fechaDesde: this.props.data.fechasModalEstados.desde,
            fechaHasta: this.props.data.fechasModalEstados.hasta
        }
        this.actualizaFechaDesde = this.actualizaFechaDesde.bind(this);
        this.actualizaFechaHasta = this.actualizaFechaHasta.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fechaDesde: nextProps.data.fechasModalEstados.desde,
            fechaHasta: nextProps.data.fechasModalEstados.hasta
        });
    }

    actualizaFechaDesde(fechaDesde) {
        this.setState({
            fechaDesde: fechaDesde,
            fechaHasta: this.state.fechaHasta
        });
    }

    actualizaFechaHasta(fechaHasta) {
        this.setState({
            fechaHasta: fechaHasta,
            fechaDesde: this.state.fechaDesde
        });
    }

    handleChangeFechaDesde = (e) => {
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }

        //Regex que permite solo números y /
        let regFecha = /^[0-9]*\/?[0-9]*\/?[0-9]*$/;
        //Valida que tenga el formato MM/AAAA
        let regFechaTotal = /^[0-9]{2}[\/]{1}[0-9]{2}[\/]{1}[0-9]{4}$/;

        let resp = regFecha.test(e.target.value);

        if (resp) {
            this.actualizaFechaDesde(e.target.value);
            if (regFechaTotal.test(e.target.value))
                this.props.actions.validarFormatoFecha(e.target.value, e.target.id, "errorDesde", true);
            else
                this.props.actions.validarFormatoFecha(e.target.value, e.target.id, "errorDesde", false);
        }
        else {
            e.preventDefault();
        }
    }

    handleChangeFechaHasta = (e) => {
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }

        //Regex que permite solo números y /
        let regFecha = /^[0-9]*\/?[0-9]*\/?[0-9]*$/;
        //Valida que tenga el formato MM/AAAA
        let regFechaTotal = /^[0-9]{2}[\/]{1}[0-9]{2}[\/]{1}[0-9]{4}$/;

        let resp = regFecha.test(e.target.value);

        if (resp) {
            this.actualizaFechaHasta(e.target.value);
            if (regFechaTotal.test(e.target.value))
                this.props.actions.validarFormatoFecha(e.target.value, e.target.id, "errorHasta", true);
            else
                this.props.actions.validarFormatoFecha(e.target.value, e.target.id, "errorHasta", false);
        }
        else {
            e.preventDefault();
        }
    }

    onClickFunction(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        }
        var rgx = /^[0-9]*\/?[0-9]*$/;
        let resp = rgx.test(event.key);

        if (!resp) {
            event.preventDefault();
        }
    }

    render() {

        const { abrirModal, camibarEstado, addUsuarioModalEstados, aceptarModalEstados } = this.props.actions;
        const { estadoSeleccionado, fechasModalEstados, usuariosEstadoPendConfrimacion, usuariosEstadoDenegado, usuariosModalEstadosSeleccionado } = this.props.data;

        let usuariosModalEstados =  estadoSeleccionado.esPendConfirmacion ? usuariosEstadoPendConfrimacion : usuariosEstadoDenegado;
        let clasePendConfirmacion = estadoSeleccionado.esPendConfirmacion ? "modal-estados-estado-seleccionado" : "modal-estados-estado-sin-seleccionar";
        let claseDenegado = estadoSeleccionado.esDenegado ? "modal-estados-estado-seleccionado" : "modal-estados-estado-sin-seleccionar";

        return (
            <div className='modalContainer'>
                <div className="modal-estados">
                    <div className="modal-content">
                        <div className="modal-estados-header">
                            <div className="close-modal-estados" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => abrirModal(false, 1)} className="ti-close clickable"></label>
                            </div>
                            <p className="modal-estados-font-header">Seleccione un estado</p>
                        </div>

                        <div>
                            <div className={clasePendConfirmacion} onClick={() => camibarEstado(true, false)}>
                                <label className="modal-estados-etiqueta-gris">PEND. CONFIRMACION</label>
                            </div>
                            <div className={claseDenegado} onClick={() => camibarEstado(false, true)}>
                                <label className="modal-estados-etiqueta-gris">DENEGADO</label>
                            </div>
                        </div>

                        <div className="modal-body-estados">
                            <div className="modal-estados-container-fecha">
                                <div>
                                    <label className="modal-estados-labels">Desde</label>
                                    <input type="text" id="desde" maxLength="10" onChange={this.handleChangeFechaDesde} onKeyPress={this.onClickFunction} name="inputFechaDesde" value={this.state.fechaDesde} className="form-control default-input" placeholder="dd/mm/aaaa" />
                                    {fechasModalEstados && fechasModalEstados.errorDesde && <label className="error modal-estados-label-error">Formato Incorrecto</label>}
                                </div>
                                <div className="left-separator-xs">
                                    <label className="modal-estados-labels">Hasta</label>
                                    <input type="text" id="hasta" maxLength="10" onChange={this.handleChangeFechaHasta} onKeyPress={this.onClickFunction} name="inputFechaHasta" value={this.state.fechaHasta} className="form-control default-input" placeholder="dd/mm/aaaa" />
                                    {fechasModalEstados && fechasModalEstados.errorHasta && <label className="error modal-estados-label-error">Formato Incorrecto</label>}
                                </div>
                            </div>
                            <div style={{ paddingTop: "30px" }}>
                                <label className="modal-estados-labels">Usuario</label>
                                <ModalEstadosBusquedaUsuarios addUsuarioModalEstados={addUsuarioModalEstados} usuariosModalEstados={usuariosModalEstados} usuariosModalEstadosSeleccionado={usuariosModalEstadosSeleccionado}/>
                            </div>
                        </div>

                        <div className="modal-estados-footer">
                            <button type="button" className="modal-estados-boton-aceptar" onClick={() => aceptarModalEstados()} data-dismiss="modal">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalEstados;